import { useSuspenseQuery } from '@tanstack/react-query';

import { useSaveClientSort, userMetadataQueryOptions } from '../api/clientSortQueries';
import { readClientSort } from '../model/clientSort';
import type { ClientFilterType, ClientSortDirection, ClientSortField } from '../model/filters';

export const useClientSort = (tab: ClientFilterType) => {
  const { data: sort } = useSuspenseQuery({
    ...userMetadataQueryOptions(),
    select: (metadata) => readClientSort(metadata, tab),
  });
  const { mutate: save } = useSaveClientSort();

  return {
    ...sort,
    setSortBy: (sortBy: ClientSortField) => save({ tab, sortBy }),
    setSortDirection: (sortDirection: ClientSortDirection) => save({ tab, sortDirection }),
  };
};
